module.exports = __webpack_public_path__ + "static/media/icon-nav-notification.e1c86986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-notification.svg
// module id = 1259
// module chunks = 19